export default "/images/vendor/flag-icon-css/flags/4x3/jm.svg?6bb96bbc99218d9f84f7edcf8012c77b";